import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { PROCESSES } from "utils/api/graphql/queries/processes";
import { DATE_FORMAT } from "utils/constants";
import { bindDateInputProps, bindInputProps } from "utils/helpers/input";
import { DEFAULT_TARIFF_KEY } from "./form";

const Fields = ({ formProps, values, setFieldValue, FORM }) => (
  <div className="grid--1">
    <Input
      label={FORM.CODE}
      placeholder={FORM.CODE}
      required
      {...bindInputProps({ name: "code", values, ...formProps })}
    />
    <Input
      label={FORM.LABEL}
      placeholder={FORM.LABEL}
      {...bindInputProps({ name: "label", values, ...formProps })}
    />
    <Select
      options={[
        {
          label: FORM.TARIFF_KEYS.PARTNER,
          value: DEFAULT_TARIFF_KEY,
        },
      ]}
      placeholder={FORM.TARIFF_KEY}
      label={FORM.TARIFF_KEY}
      {...bindInputProps({
        name: "tariffKey",
        values,
        ...formProps,
      })}
    />
    <Select
      type="async"
      showSearch
      node={{
        query: PROCESSES,
        variables: { orderBy: [{ name: "ASC" }], take: null },
        accessors: {
          root: "processes.data",
          label: "name",
        },
      }}
      placeholder={FORM.PROCESS}
      label={FORM.PROCESS}
      required
      value={values.process && values.process.id}
      {...bindInputProps({
        name: "process.id",
        values,
        ...formProps,
      })}
      onChange={(id) => setFieldValue("process", { id: id || "" })}
    />
    <Input
      type="switch"
      label={FORM.ACTIVE}
      checked={values.active}
      onChange={(checked) => setFieldValue("active", checked)}
    />
    <Input
      type="date"
      label={FORM.START_DATE}
      format={DATE_FORMAT}
      {...bindDateInputProps({
        name: "startDate",
        values,
        ...formProps,
      })}
    />
    <Input
      type="date"
      label={FORM.END_DATE}
      format={DATE_FORMAT}
      {...bindDateInputProps({
        name: "endDate",
        values,
        ...formProps,
      })}
    />
  </div>
);

export default Fields;
